'use client'
import { useState, useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { Listbox } from '@headlessui/react'
import { RiArrowDropDownLine } from 'react-icons/ri'
import { FaCheck } from "react-icons/fa";

import tailwindConfig from '@tailwind.config'

import { getSearchParams, updateCategoriesParams, removeSearchParam } from "@utils";
import { categoriesTypes } from '@constants/categoriesTypes';

const defaultValue = {
    'en': 'Any',
    'th': 'อื่นๆ',
    'cn': '所有',
    'ru':'Любой'
}

const CategoriesFilter = ({ title, lang, dictionary }) => {
    const router = useRouter();
    const [selectedCategories, setSelectedCategories] = useState([]);

    useEffect(() => {
        // Fetch categories from URL parameters on component mount
        const categoriesValue = getSearchParams('categories');
        if (categoriesValue) {
            const selectedCategories = categoriesValue.split(',');
            setSelectedCategories(selectedCategories);
        }
    }, []);

    const toggleCategory = (category) => {
        // Toggle the selection of a category
        let newSelectedCategories;
        if (selectedCategories.includes(category.value)) {
            newSelectedCategories = selectedCategories.filter(cat => cat !== category.value);
        } else {
            newSelectedCategories = [...selectedCategories, category.value];
        }
        setSelectedCategories(newSelectedCategories);

        // Update URL with new selected categories
        const newPathName = newSelectedCategories.length > 0
            ? updateCategoriesParams(newSelectedCategories.join(','))
            : removeSearchParam(title);
        router.push(newPathName);
    };

    return (
        <div className="w-full relative mb-2">
            <span className='text-sm text-secondary'>{dictionary.filter.category}:</span>
            <Listbox value={selectedCategories} onChange={setSelectedCategories} multiple>
                <div className="w-full">
                    <div className='z-1 w-full mt-1 cursor-default overflow-hidden rounded-lg bg-white shadow-md text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                        <Listbox.Button className='w-full relative border-none py-2 pl-3 pr-10 text-sm flex items-center leading-5 text-gray-900 focus:ring-0'>
                            {selectedCategories.length === 0 ? defaultValue[lang] : selectedCategories.join(', ')}
                            <span className="absolute inset-y-0 right-0 flex items-center pr-2">
                                <RiArrowDropDownLine
                                    color={tailwindConfig.theme.extend.colors.secondary}
                                    size={28}
                                />
                            </span>
                        </Listbox.Button>
                    </div>
                    <Listbox.Options className='z-50 left-0 right-0 absolute bg-white h-auto overflow-y-auto shadow-md rounded-md py-1'>
                        {categoriesTypes[lang].map((category) => (
                            <Listbox.Option
                                key={category.value}
                                value={category.value}
                                onClick={() => toggleCategory(category)}
                            >
                                {({ active }) => (
                                    <span className={`p-2 cursor-pointer flex flex-row items-center ${active ? 'bg-maincolor text-light' : ''}`}>
                                        {selectedCategories.includes(category.value) && <FaCheck className='mr-2' />}
                                        {category.title}
                                    </span>
                                )}
                            </Listbox.Option>
                        ))}
                    </Listbox.Options>
                </div>
            </Listbox>
        </div>
    );
}

export default CategoriesFilter;